// Small helpers for blåtur trips (events with event_type 'Blåtur🌍'), without Firebase dependencies

export const BLATUR_TYPE = 'Blåtur🌍';

// "2026 Q3" -> 2026
export const tripYear = (trip) => parseInt((trip.Kvartal || '').split(' ')[0], 10) || null;

// "Italia-Toscana" -> "Toscana, Italia"
export const tripTitle = (trip) => {
  const parts = (trip.sted_konsept || '').split('-');
  return parts.length === 2 ? `${parts[1].trim()}, ${parts[0].trim()}` : trip.sted_konsept;
};

// Group photo: explicit cover image, otherwise the first uploaded image
export const tripCover = (trip) => trip.coverImage || trip.images?.[0] || null;
